import { CombinatorChip } from '@reveni-io/reveni-ui'

import ConditionCard from './ConditionCard/ConditionCard'
import { getErrorCriteriaIndexes } from './helpers'
import * as Styles from './styles'

const ConditionsList = ({
  conditions,
  onChange,
  onRemove,
  disabled,
  errors = [],
  conditionTypes,
  errorType,
  currencies,
  storeCurrencyCode,
}) => {
  if (conditions.length === 0) {
    return null
  }

  return (
    <Styles.Container>
      {conditions.map((condition, index) => (
        <Styles.ConditionWrapper key={index}>
          {index > 0 && (
            <Styles.CombinatorContainer>
              <CombinatorChip variant="AND" />
            </Styles.CombinatorContainer>
          )}
          <ConditionCard
            condition={condition}
            index={index}
            onChange={onChange}
            onRemove={onRemove}
            disabled={disabled}
            errorCriteriaIndexes={getErrorCriteriaIndexes(errors, errorType, index)}
            conditionTypes={conditionTypes}
            currencies={currencies}
            storeCurrencyCode={storeCurrencyCode}
          />
        </Styles.ConditionWrapper>
      ))}
    </Styles.Container>
  )
}

export default ConditionsList
